import React from 'react';
import { droplet2 } from '@nuvolo/nuux-theme';
import merge from 'deepmerge';
import logoSeal from '#/static/tt-logo-seal.png';
import type { NuvoTheme, PartialDeep } from '@nuvolo/nuux-theme/types';
import { lightColors, lightThemeLogo } from '#/config/themes/light';
import { darkColors, darkThemeLogo } from '#/config/themes/dark';

const selectedThemeColors = darkColors;
const selectedThemeLogo = selectedThemeColors === darkColors ? darkThemeLogo : lightThemeLogo;

const tmmTheme: PartialDeep<NuvoTheme> = {
  colors: selectedThemeColors,
  fontConfig: {
    fontFamily: {
      base: "'Inter', Arial, sans-serif",
    },
    fontSizes: {
      h1: '28px',
      h2: '24px',
      h3: '14px',
      large: '16px',
      base: '14px',
      baseSize: '14px',
      small: '12px',
    },
    fontWeights: {
      regular: '400',
      extraBold: '600',
    },
  },
  layout: {
    borderRadius: {
      base: '8px',
      xs: '8px',
      s: '16px',
      m: '24px',
      l: '40px',
      // HOW TO USE BORDER RADIUS IN STYLED COMPONENTS
      // import { borderRadius } from '../common/hooks/useClientTheme';
      // border-radius: ${borderRadius?.m};
    } as any,
  },
};

// Merge droplet2 with our custom theme
const theme = merge<NuvoTheme, PartialDeep<NuvoTheme>>(droplet2, tmmTheme);

export const fontFamily = tmmTheme.fontConfig?.fontFamily?.base;
export const fontSizes = tmmTheme.fontConfig?.fontSizes as CustomFontSizes | undefined;
export const borderRadius = tmmTheme.layout?.borderRadius as CustomBorderRadius | undefined;
export const nuvoloLogo = selectedThemeLogo;

type CustomFontSizes = {
  h1?: string;
  h2?: string;
  h3?: string;
  large?: string;
  base?: string;
  baseSize?: string;
  small?: string;
};

type CustomBorderRadius = {
  base?: string;
  xs?: string;
  s?: string;
  m?: string;
  l?: string;
};

const useClientTheme = () => {
  return {
    theme,
    logo: <img src={logoSeal} alt="Trane Technologies" width="100%" height="100%" />,
  };
};

export default useClientTheme;
